import React, { useState } from "react";
import * as XLSX from "xlsx";

function ExcelReader() {
  const [excelData, setExcelData] = useState([]);
  const [error, setError] = useState("");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Chọn sheet đầu tiên
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Chuyển đổi dữ liệu sheet thành JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: "A" });

        // Kiểm tra cột
        const headers = jsonData[0];
        if (headers.A === "gmail" && headers.B === "giới tính") {
          setExcelData(jsonData.slice(1)); // Bỏ hàng tiêu đề
          setError(""); // Xóa lỗi nếu có
        } else {
          setError("File Excel phải có cột 'gmail' và 'giới tính'.");
          setExcelData([]);
        }
      };
      reader.readAsArrayBuffer(file);
    } else {
      alert("Vui lòng chọn một file Excel.");
    }
  };

  return (
    <div className="flex flex-col items-center p-6 font-sans">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Tải lên và đọc file Excel
      </h1>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        className="px-4 py-2 border border-gray-300 rounded-md cursor-pointer mb-4"
      />

      {error && <p className="text-red-500 font-semibold mb-4">{error}</p>}

      {excelData.length > 0 && (
        <table className="w-full max-w-lg border border-collapse mt-4">
          <thead>
            <tr>
              <th className="bg-green-600 text-white px-4 py-2 text-left font-medium">
                Gmail
              </th>
              <th className="bg-green-600 text-white px-4 py-2 text-left font-medium">
                Giới tính
              </th>
            </tr>
          </thead>
          <tbody>
            {excelData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={rowIndex % 2 === 0 ? "bg-gray-100" : "bg-white"}
              >
                <td className="border px-4 py-2 text-gray-700">{row.A}</td>
                <td className="border px-4 py-2 text-gray-700">{row.B}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ExcelReader;
